export enum MessageType {
  Referees = "Referees",
  Customers = "Customers",
}

export interface MessageState {
  currentChatType: MessageType;
}
